import {Component, input, output} from '@angular/core';
import {TagDto} from '../../models/tag-dto';

/**
 * Presentational, always-visible **tag pill strip** for the items (Artikel) create/edit slide-over.
 *
 * Renders each tag as a touch-friendly, keyboard-accessible pill and emits {@link toggle} when one is
 * pressed — it holds no selection state itself (the parent owns `create.tags`). The strip wraps and scrolls
 * vertically inside a compact max height; it is intentionally **not** height-gated (the old
 * `hidden tall:flex` gate hid it on phones). See `docs/articles/inventory/items-management.md`.
 */
@Component({
  selector: 'app-item-tag-picker',
  standalone: true,
  templateUrl: './item-tag-picker.component.html',
  styleUrl: './item-tag-picker.component.scss'
})
export class ItemTagPickerComponent {
  /** All selectable tags (already filtered to non-`allCompositions` by the caller). */
  readonly tags = input<TagDto[]>([]);
  /** Ids of the currently-selected tags. */
  readonly selectedIds = input<string[]>([]);
  /** Emitted with the tag whose pill was pressed. */
  readonly toggle = output<TagDto>();

  /** Whether `tag` is currently selected. */
  isSelected(tag: TagDto): boolean {
    return this.selectedIds().includes(tag.id);
  }
}
